// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"7cf2346f","267":"25108852","352":"d26ed3d7","452":"8d474e57","594":"ea811910","617":"cd84cd7a","771":"d6f56f3f"}[chunkId] + ".chunk.css";
};